<div class="playground-layout">
  <h2>Playground</h2>
  <div class="container">
    <div class="row">
      <div class="column">
        <div class="card">
          <h3>Text Resources</h3>   
          <input aria-label=""  
          type="text" 
          [(ngModel)]="textResourceKey"
          id="txtTextResourceKey" 
          name="pcn" 
          class="app-input"
          placeholder="please enter text resource id" 
          triggers="manual" 
          placement="right">
          <button class="button" (click)="getTextResource()">Get Text</button>   
          <!-- <p>{{textResourceValue}}</p>     -->
          <div style="padding-top: 20px;" [innerHTML]="textResourceValue"></div>  
        </div>
      </div>
    
      <div class="column">
        <div class="card">
          <h3></h3>
          <p></p>
          <p></p>
        </div>
      </div>
      
      <div class="column">
        <div class="card">
          <h3>Settings</h3>
          <div class="row">
            <p class="col-2 b-3 font-weight-bold"> Setting </p>
            <p class="col-5 b-3 font-weight-bold"> Value </p>
          </div>
          <ng-container  *ngFor="let info of appSettingInfo">
            <div class="row">
                    <div class="col-2" > {{info[0]}} </div>
                    <div class="col-5" > {{info[1]}} </div>
            </div>
          </ng-container>
        </div>
      </div>
      
      <div class="column">
        <div class="card">
          <h3></h3>
          <p></p>
          <p></p>
        </div>
      </div>
    </div>
  </div>

</div>
